export enum FiskilRedirectEnum {
  status = "status",
  redirect = "redirect",
  success = "success",
  fiskil = "fiskil",
}
